export const CONFIRM_EMAIL_ROUTES = {
    CONFIRM_EMAIL: {
        PATH: 'confirm-email/:id',
        TITLE: 'Confirm Email',
    },
};
